import type { ReactElement } from 'react';
import { t } from '@fetmode/i18n';

import './ThumbGridPager.css';

export interface ThumbGridPagerProps {
  page: number;
  total: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  label: string;
}

export function ThumbGridPager({
  page,
  total,
  pageSize,
  onPageChange,
  label,
}: ThumbGridPagerProps): ReactElement | null {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) {
    return null;
  }

  const status = t('common.home.pageStatus')
    .replace('{{current}}', String(page))
    .replace('{{total}}', String(pageCount));

  return (
    <nav className="thumb-grid-pager" aria-label={label}>
      <button
        type="button"
        className="thumb-grid-pager__btn"
        disabled={page <= 1}
        onClick={() => {
          onPageChange(page - 1);
        }}
      >
        {t('common.home.pagePrev')}
      </button>
      <p className="thumb-grid-pager__status">{status}</p>
      <button
        type="button"
        className="thumb-grid-pager__btn"
        disabled={page >= pageCount}
        onClick={() => {
          onPageChange(page + 1);
        }}
      >
        {t('common.home.pageNext')}
      </button>
    </nav>
  );
}
